import {
    GET_FINAL_DECISIONS,
    GET_FINAL_DECISIONS_SUCCESS,
    GET_FINAL_DECISIONS_FAIL,

    GET_RETEST_CANDIDATES,
    GET_RETEST_CANDIDATES_SUCCESS,
    GET_RETEST_CANDIDATES_FAIL, 

} from "./actionTypes";

const INIT_STATE = {
    finalDecisions: [],
    retestCandidates: [], // State dédié
    loadingRetest: false, // Loading dédié
    sessionInfo: null,
    loading: false,
    error: null,
};

const finalDecisionReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_FINAL_DECISIONS:
            return { 
                ...state, 
                loading: true 
            };

        case GET_FINAL_DECISIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                // On mappe directement les clés envoyées par l'API Laravel
                finalDecisions: action.payload.finalDecisions || [],
                sessionInfo:    action.payload.sessionInfo || null,
                error: null
            };

        case GET_FINAL_DECISIONS_FAIL:
            return { 
                ...state, 
                loading: false, 
                error: action.payload 
            };

        case GET_RETEST_CANDIDATES:
            return { ...state, loadingRetest: true };

        case GET_RETEST_CANDIDATES_SUCCESS:
            return { 
                ...state, 
                retestCandidates: action.payload.retestCandidates, // On reçoit directement la liste filtrée par l'API
                loadingRetest: false 
            };

        case GET_RETEST_CANDIDATES_FAIL:
            return { ...state, error: action.payload, loadingRetest: false };

        default:
            return state;
    }
};

export default finalDecisionReducer;